/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelPartialShipmentManifestOrderDetails.ts  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/partial-shipment-manifest-order-details";

export class AutogenModelPartialShipmentManifestOrderDetails<RowType extends ModelRow> extends Endpoint<RowType, RowPartialShipmentManifestOrderDetailsFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowPartialShipmentManifestOrderDetails extends ModelRow<RowPartialShipmentManifestOrderDetailsFields> {
	constructor(values?: Partial<RowPartialShipmentManifestOrderDetailsFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowPartialShipmentManifestOrderDetailsFields {
	company_id: string;
	"consignee.actual_arrival": Date;
	"consignee.actual_departure": Date;
	"consignee.address": string;
	"consignee.address2": string;
	"consignee.appointment_status_id": string;
	"consignee.appt_contact_name": string;
	"consignee.appt_required": string;
	"consignee.cases": number;
	"consignee.city_id": number;
	"consignee.city_name": string;
	"consignee.company_id": string;
	"consignee.confirmed": string;
	"consignee.contact_email": string;
	"consignee.contact_name": string;
	"consignee.dist_from_prev": number;
	"consignee.dist_from_prev_um": string;
	"consignee.driver_load_unload": string;
	"consignee.edi_code": string;
	"consignee.edi_loc_code": string;
	"consignee.eta": Date;
	"consignee.eta_distance": number;
	"consignee.eta_late": string;
	"consignee.eta_oor": string;
	"consignee.google_place_id": string;
	"consignee.grouped_id": number;
	"consignee.hub": number;
	"consignee.ic_stop_id": string;
	"consignee.id": string;
	"consignee.inbound_status": string;
	"consignee.late_eta_colorcode": string;
	"consignee.late_route_status": string;
	"consignee.latitude": number;
	"consignee.location_id": string;
	"consignee.location_name": string;
	"consignee.longitude": number;
	"consignee.manifest_fgp_uid": number;
	"consignee.manifest_reg_uid": number;
	"consignee.move_dist_from_preassign": number;
	"consignee.move_dist_from_preassign_um": string;
	"consignee.move_dist_from_previous": number;
	"consignee.move_dist_from_previous_um": string;
	"consignee.movement_id": string;
	"consignee.movement_sequence": number;
	"consignee.operational_status": string;
	"consignee.order_id": string;
	"consignee.order_sequence": number;
	"consignee.orig_sched_early": Date;
	"consignee.orig_sched_late": Date;
	"consignee.pallets_dropped": number;
	"consignee.pallets_picked_up": number;
	"consignee.payment_code_reviewed": string;
	"consignee.phone": string;
	"consignee.planned_arrival_time": Date;
	"consignee.ponum": string;
	"consignee.prior_uncleared_stops": string;
	"consignee.projected_arrival": Date;
	"consignee.pu_override_arrive_early": Date;
	"consignee.pu_override_arrive_late": Date;
	"consignee.rate_dist_from_previous": number;
	"consignee.rate_dist_from_previous_um": string;
	"consignee.refno": string;
	"consignee.requested_service": string;
	"consignee.sched_arrive_early": Date;
	"consignee.sched_arrive_late": Date;
	"consignee.seal": string;
	"consignee.service_date": Date;
	"consignee.showas_address": string;
	"consignee.showas_address2": string;
	"consignee.showas_city_id": number;
	"consignee.showas_city_name": string;
	"consignee.showas_location_id": string;
	"consignee.showas_location_name": string;
	"consignee.showas_state": string;
	"consignee.showas_zip_code": string;
	"consignee.signed_for_name": string;
	"consignee.state": string;
	"consignee.status": string;
	"consignee.stop_type": string;
	"consignee.trimble_place_id": string;
	"consignee.txl_uid": number;
	"consignee.volume": number;
	"consignee.volume_um": string;
	"consignee.weight": number;
	"consignee.weight_um": string;
	"consignee.zip_code": string;
	"consignee.zone_id": string;
	id: string;
	movement_id: string;
	on_at_move_dest: string;
	on_at_move_origin: string;
	order_id: string;
	"orders.actual_reefer_profile": string;
	"orders.agency_id": string;
	"orders.agent_payee_id": string;
	"orders.all_vendors_enabled": string;
	"orders.allow_relay": string;
	"orders.autorate_status": string;
	"orders.bill_date": Date;
	"orders.bill_distance": number;
	"orders.bill_distance_um": string;
	"orders.billing_empty_distance": number;
	"orders.billing_empty_distance_um": string;
	"orders.billing_loaded_distance": number;
	"orders.billing_loaded_distance_um": string;
	"orders.billing_user_id": string;
	"orders.blnum": string;
	"orders.bol_note": string;
	"orders.bol_received": string;
	"orders.bol_recv_date": Date;
	"orders.booking_no": string;
	"orders.booking_number": string;
	"orders.brk_qual_profile": string;
	"orders.broker_location_id": string;
	"orders.brokerage_workflow_id": string;
	"orders.carrier_scorecard_export_dt": Date;
	"orders.carrier_scorecard_exported": string;
	"orders.cbp_crossing_date": Date;
	"orders.cbp_crossing_location_id": string;
	"orders.cbp_crossing_reason": string;
	"orders.cbsa_crossing_date": Date;
	"orders.cbsa_crossing_location_id": string;
	"orders.cbsa_crossing_reason": string;
	"orders.cc_fuel_revenue": number;
	"orders.cc_fuel_revenue_c": string;
	"orders.cc_fuel_revenue_d": Date;
	"orders.cc_fuel_revenue_n": number;
	"orders.cc_fuel_revenue_r": number;
	"orders.cc_net_revenue": number;
	"orders.cc_net_revenue_c": string;
	"orders.cc_net_revenue_d": Date;
	"orders.cc_net_revenue_n": number;
	"orders.cc_net_revenue_r": number;
	"orders.cc_pro_nbr": string;
	"orders.cobroker_location_id": string;
	"orders.collection_method": string;
	"orders.com_setpnt_temp": number;
	"orders.com_setpnt_temp_dt": Date;
	"orders.com_setpnt_temp_um": string;
	"orders.commitment_id": string;
	"orders.commodity": string;
	"orders.commodity_id": string;
	"orders.company_id": string;
	"orders.consignee_refno": string;
	"orders.consignee_stop_id": string;
	"orders.container": string;
	"orders.container_planned": string;
	"orders.container_type_id": string;
	"orders.controlling_carrier_code": string;
	"orders.copy_from_company": string;
	"orders.copy_from_order_id": string;
	"orders.copy_to_company": string;
	"orders.copy_to_order_id": string;
	"orders.ctrl_party_id": string;
	"orders.cube": number;
	"orders.curr_movement_id": string;
	"orders.cust_order_no": string;
	"orders.customer_id": string;
	"orders.declared_val": number;
	"orders.def_move_type": string;
	"orders.default_match_id": string;
	"orders.dim_height": string;
	"orders.dim_length": string;
	"orders.dim_surcharge": number;
	"orders.dim_surcharge_c": string;
	"orders.dim_surcharge_d": Date;
	"orders.dim_surcharge_n": number;
	"orders.dim_surcharge_r": number;
	"orders.dim_width": string;
	"orders.dispatch_opt": string;
	"orders.dl_team_reqd": string;
	"orders.dray_del_date": Date;
	"orders.dray_del_pay": number;
	"orders.dray_del_pay_c": string;
	"orders.dray_del_pay_d": Date;
	"orders.dray_del_pay_n": number;
	"orders.dray_del_pay_r": number;
	"orders.dray_del_payee": string;
	"orders.dray_del_xfer_dt": Date;
	"orders.dray_pu_date": Date;
	"orders.dray_pu_pay": number;
	"orders.dray_pu_pay_c": string;
	"orders.dray_pu_pay_d": Date;
	"orders.dray_pu_pay_n": number;
	"orders.dray_pu_pay_r": number;
	"orders.dray_pu_payee": string;
	"orders.dray_pu_xfer_dt": Date;
	"orders.eir1_no": string;
	"orders.eir2_no": string;
	"orders.entered_user_id": string;
	"orders.equipment_type_id": string;
	"orders.equipment_type_options": string;
	"orders.est_tolls": number;
	"orders.est_tolls_c": string;
	"orders.est_tolls_d": Date;
	"orders.est_tolls_n": number;
	"orders.est_tolls_r": number;
	"orders.excise_disable_update": string;
	"orders.excise_taxable": string;
	"orders.excisetax_total": number;
	"orders.excisetax_total_c": string;
	"orders.excisetax_total_d": Date;
	"orders.excisetax_total_n": number;
	"orders.excisetax_total_r": number;
	"orders.external_invoiceno": string;
	"orders.extra_deliveries": number;
	"orders.extra_pickups": number;
	"orders.floor_loaded_freight": string;
	"orders.force_assign": string;
	"orders.forwd_location_id": string;
	"orders.free_days": number;
	"orders.freight_charge": number;
	"orders.freight_charge_c": string;
	"orders.freight_charge_d": Date;
	"orders.freight_charge_n": number;
	"orders.freight_charge_r": number;
	"orders.hazmat": string;
	"orders.hazmat_code": string;
	"orders.high_value": string;
	"orders.hold_reason": string;
	"orders.ic_company_from": string;
	"orders.ic_movement_from": string;
	"orders.ic_order_from": string;
	"orders.id": string;
	"orders.image_is_present": string;
	"orders.import_export": string;
	"orders.include_split_point": string;
	"orders.intelliset": string;
	"orders.invoice_recv_date": Date;
	"orders.is_auto_tonu": string;
	"orders.is_autorate_dist": string;
	"orders.is_container": string;
	"orders.is_dedicated": string;
	"orders.is_intercompany": string;
	"orders.is_local_mile": string;
	"orders.is_requested": string;
	"orders.is_tonu": string;
	"orders.jag_carrier_id": string;
	"orders.jag_cost_rate_id": number;
	"orders.ldport_location_id": string;
	"orders.linear_feet_avail": number;
	"orders.load_date": Date;
	"orders.loadboard": string;
	"orders.loadboard_post_movement_id": string;
	"orders.loadboard_posting_cancelled": string;
	"orders.lock_miles": string;
	"orders.ltl": string;
	"orders.markup_flat": number;
	"orders.markup_flat_c": string;
	"orders.markup_flat_d": Date;
	"orders.markup_flat_n": number;
	"orders.markup_flat_r": number;
	"orders.markup_percent": number;
	"orders.master_order_id": string;
	"orders.master_sequence": number;
	"orders.next_rebill": string;
	"orders.nte_lp_num": string;
	"orders.nte_lp_qual": string;
	"orders.on_hold": string;
	"orders.operational_status": string;
	"orders.operations_user": string;
	"orders.optimize": string;
	"orders.optiset": string;
	"orders.order_mode": string;
	"orders.order_type_id": string;
	"orders.order_value": number;
	"orders.order_value_c": string;
	"orders.order_value_d": Date;
	"orders.order_value_n": number;
	"orders.order_value_r": number;
	"orders.ordered_by": string;
	"orders.ordered_by_id": string;
	"orders.ordered_date": Date;
	"orders.ordered_method": string;
	"orders.orig_dest_rate_id": string;
	"orders.otherchargetotal": number;
	"orders.otherchargetotal_c": string;
	"orders.otherchargetotal_d": Date;
	"orders.otherchargetotal_n": number;
	"orders.otherchargetotal_r": number;
	"orders.override_arrive_early": Date;
	"orders.override_arrive_late": Date;
	"orders.override_posting_city_id": number;
	"orders.pallets_how_many": number;
	"orders.pallets_required": string;
	"orders.pay_gross": number;
	"orders.pay_gross_c": string;
	"orders.pay_gross_d": Date;
	"orders.pay_gross_n": number;
	"orders.pay_gross_r": number;
	"orders.pick_up_no": string;
	"orders.pieces": number;
	"orders.placard_required": string;
	"orders.planning_comment": string;
	"orders.pnn_callback": string;
	"orders.pnn_comment": string;
	"orders.pnn_comment2": string;
	"orders.pnn_loadboard_user_id": string;
	"orders.pnn_post_type": string;
	"orders.pnn_rate": number;
	"orders.pnn_rate_type": string;
	"orders.pnn_trailer_length": number;
	"orders.pnn_trailer_width": number;
	"orders.ponum": string;
	"orders.port": string;
	"orders.port_of_discharge": string;
	"orders.preferred_vendors": string;
	"orders.preload_trailer_id": string;
	"orders.preloaded": string;
	"orders.rate": number;
	"orders.rate_currency_type": string;
	"orders.rate_id": number;
	"orders.rate_min_weight": number;
	"orders.rate_min_weight_um": string;
	"orders.rate_source": string;
	"orders.rate_type": string;
	"orders.rate_unit_desc": string;
	"orders.rate_units": number;
	"orders.ready_to_bill": string;
	"orders.recurring_order_id": string;
	"orders.reply_transmitted": string;
	"orders.requesting_company": string;
	"orders.return_temp": number;
	"orders.return_temp_dt": Date;
	"orders.return_temp_um": string;
	"orders.return_temp_var": number;
	"orders.return_temp_var_um": string;
	"orders.revenue_code_id": string;
	"orders.revenue_share_method": string;
	"orders.round_trip": string;
	"orders.sail_date": Date;
	"orders.seal_number": string;
	"orders.seg_alloc_code": string;
	"orders.setpoint_temp": number;
	"orders.setpoint_temp_um": string;
	"orders.setpoint_var": number;
	"orders.setpoint_var_um": string;
	"orders.ship_status_to_edi": string;
	"orders.shipment_id": string;
	"orders.shipper_stop_id": string;
	"orders.shipstatus2edi_dt": Date;
	"orders.ss_location_id": string;
	"orders.status": string;
	"orders.subject_order_number": string;
	"orders.subject_order_status": string;
	"orders.subject_order_void_date": Date;
	"orders.swap": string;
	"orders.teams_required": string;
	"orders.temperature_max": number;
	"orders.temperature_max_um": string;
	"orders.temperature_min": number;
	"orders.temperature_min_um": string;
	"orders.temperature_um": string;
	"orders.total_charge": number;
	"orders.total_charge_c": string;
	"orders.total_charge_d": Date;
	"orders.total_charge_n": number;
	"orders.total_charge_r": number;
	"orders.totalcharge_and_excisetax": number;
	"orders.totalcharge_and_excisetax_c": string;
	"orders.totalcharge_and_excisetax_d": Date;
	"orders.totalcharge_and_excisetax_n": number;
	"orders.totalcharge_and_excisetax_r": number;
	"orders.tractor_type": string;
	"orders.vessel": string;
	"orders.vessel_cutoff_date": Date;
	"orders.voided_load_transmitted": string;
	"orders.voided_load_transmitted_dt": Date;
	"orders.weight": number;
	"orders.weight_um": string;
	"orders.xferred2billing": string;
	"orders.xferred2billing_dt": Date;
	planned_manifest_id: string;
	sequence: number;
	"shipper.actual_arrival": Date;
	"shipper.actual_departure": Date;
	"shipper.address": string;
	"shipper.address2": string;
	"shipper.appointment_status_id": string;
	"shipper.appt_contact_name": string;
	"shipper.appt_required": string;
	"shipper.cases": number;
	"shipper.city_id": number;
	"shipper.city_name": string;
	"shipper.company_id": string;
	"shipper.confirmed": string;
	"shipper.contact_email": string;
	"shipper.contact_name": string;
	"shipper.dist_from_prev": number;
	"shipper.dist_from_prev_um": string;
	"shipper.driver_load_unload": string;
	"shipper.edi_code": string;
	"shipper.edi_loc_code": string;
	"shipper.eta": Date;
	"shipper.eta_distance": number;
	"shipper.eta_late": string;
	"shipper.eta_oor": string;
	"shipper.google_place_id": string;
	"shipper.grouped_id": number;
	"shipper.hub": number;
	"shipper.ic_stop_id": string;
	"shipper.id": string;
	"shipper.inbound_status": string;
	"shipper.late_eta_colorcode": string;
	"shipper.late_route_status": string;
	"shipper.latitude": number;
	"shipper.location_id": string;
	"shipper.location_name": string;
	"shipper.longitude": number;
	"shipper.manifest_fgp_uid": number;
	"shipper.manifest_reg_uid": number;
	"shipper.move_dist_from_preassign": number;
	"shipper.move_dist_from_preassign_um": string;
	"shipper.move_dist_from_previous": number;
	"shipper.move_dist_from_previous_um": string;
	"shipper.movement_id": string;
	"shipper.movement_sequence": number;
	"shipper.operational_status": string;
	"shipper.order_id": string;
	"shipper.order_sequence": number;
	"shipper.orig_sched_early": Date;
	"shipper.orig_sched_late": Date;
	"shipper.pallets_dropped": number;
	"shipper.pallets_picked_up": number;
	"shipper.payment_code_reviewed": string;
	"shipper.phone": string;
	"shipper.planned_arrival_time": Date;
	"shipper.ponum": string;
	"shipper.prior_uncleared_stops": string;
	"shipper.projected_arrival": Date;
	"shipper.pu_override_arrive_early": Date;
	"shipper.pu_override_arrive_late": Date;
	"shipper.rate_dist_from_previous": number;
	"shipper.rate_dist_from_previous_um": string;
	"shipper.refno": string;
	"shipper.requested_service": string;
	"shipper.sched_arrive_early": Date;
	"shipper.sched_arrive_late": Date;
	"shipper.seal": string;
	"shipper.service_date": Date;
	"shipper.showas_address": string;
	"shipper.showas_address2": string;
	"shipper.showas_city_id": number;
	"shipper.showas_city_name": string;
	"shipper.showas_location_id": string;
	"shipper.showas_location_name": string;
	"shipper.showas_state": string;
	"shipper.showas_zip_code": string;
	"shipper.signed_for_name": string;
	"shipper.state": string;
	"shipper.status": string;
	"shipper.stop_type": string;
	"shipper.trimble_place_id": string;
	"shipper.txl_uid": number;
	"shipper.volume": number;
	"shipper.volume_um": string;
	"shipper.weight": number;
	"shipper.weight_um": string;
	"shipper.zip_code": string;
	"shipper.zone_id": string;
}

